/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    GitLabAvailableProject,
    GitLabAvailableProjectFromJSON,
    GitLabAvailableProjectToJSON,
} from './';

/**
 * 
 * @export
 * @interface GitLabAvailableProjects
 */
export interface GitLabAvailableProjects {
    /**
     * 
     * @type {Array<GitLabAvailableProject>}
     * @memberof GitLabAvailableProjects
     */
    projects: Array<GitLabAvailableProject>;
}

export function GitLabAvailableProjectsFromJSON(json: any): GitLabAvailableProjects {
    return {
        
        'projects': (json['projects'] as Array<any>).map(GitLabAvailableProjectFromJSON),
        
    };
}

export function GitLabAvailableProjectsToJSON(value?: GitLabAvailableProjects): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        
        'projects': (value.projects as Array<any>).map(GitLabAvailableProjectToJSON),
        
    };
}


